// import { Bathroom } from '../../view/enums/Bathroom';
import { SeoMapper } from '@search/router/src';

export const parkingsMapper = new SeoMapper('parkingsMapper', {
    UNKNOWN: 'UNKNOWN',
    CLOSED: 'CLOSED',
    UNDERGROUND: 'UNDERGROUND',
    OPEN: 'OPEN'
} as const);
